<template>

    <section class="subscription">
        <div class="row">
            <div class="first"></div>
            <div class="second"><p>Дарим 500 руб.</p><p>за подписку на первый заказ!</p></div>
            <div class="third">
                <q-input square
                         outlined
                         v-model="form.email"
                         label="Ваша эл. почта"
                         :error-message="form.errors.get('email')"
                         :error="form.errors.has('email')">
                    <template v-slot:after>
                        <q-btn color="secondary" label="Подписаться" @click="submitSubscription" />
                    </template>
                </q-input>
                <span class="confirmation">Нажимая на кнопку, я даю согласие на обработку <a @click.prevent="$root.redirect('/offer/#privacy')" href="javascript: void(0)" title="Конфиденциальность и защита">персональных данных</a></span>
            </div>
        </div>
        <info-dialog ref="dialog">
            <template v-slot:title>
                Уважаемый покупатель
            </template>
            <template v-slot:content>
                <p>Благодарим за то, что подписались на нашу email-рассылку. Теперь Вы будете получать актуальные новости и акции примерно один раз в неделю. Доброго дня!</p>
                <p>Мы готовы ответить на ваши вопросы по электронной почте <strong><a href='mailto:info@kc-shoes.ru'>info@kc-shoes.ru</a></strong> или по телефону <strong>8 (800) 700-27-68</strong> (звонок бесплатный)</p>
            </template>
        </info-dialog>
    </section>
</template>

<script>
    import { Form } from '../classes/Form';

    export default {
        name: "Subscription",
        data () {
            return {
                form: new Form({
                    email: '',
                    accept: false,
                }),
            }
        },
        methods: {
            submit () {
                let _this = this;

                _this.form.post('/subscribe')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.$refs['dialog'].show();
                            _this.form.reset();

                            window.events.onSubscribe();
                        }
                    });
            },
            submitSubscription () {
                let _this = this;
                _this.submit();
            }
        }
    }
</script>
